export function podeAdministrarBoletos(capability, hasPermission) {
  return capability?.boletosAdministracao === true && hasPermission('financeiro_cobrancas_configurar');
}
export function podeConsultarHistoricoBoletos(capability, hasPermission) {
  return capability?.boletosTemHistorico === true && hasPermission('financeiro_cobrancas_visualizar');
}
export function mostrarMenuBoletos(capability, hasPermission) {
  if (typeof capability?.boletosOperacionais !== 'boolean' ||
      typeof capability?.boletosTemHistorico !== 'boolean') return false;
  return capability.boletosOperacionais
    ? hasPermission('financeiro_cobrancas_visualizar') || hasPermission('financeiro_cobrancas_configurar')
    : podeConsultarHistoricoBoletos(capability, hasPermission);
}
export function rotaBoletosAtiva(path) {
  return path === '/financeiro/cobrancas' || path.startsWith('/financeiro/cobrancas/');
}
export function contasParaConfiguracao(contas, isEdit, contaId) {
  return contas.filter(conta => conta.boletos_habilitados === true ||
    (isEdit && String(conta.id) === String(contaId)));
}

export function podeOperarBoletos(capability, hasPermission) {
  return capability?.boletosOperacionais === true && hasPermission('financeiro_cobrancas_operar');
}

// Do not use the generic hasPermission administrator bypass for this switch.
export function podeAlterarModuloBoletos(permissions) {
  if (!Array.isArray(permissions)) return false;
  return permissions.includes('super_administrador') ||
    (permissions.includes('administrador') && permissions.includes('financeiro_cobrancas_configurar'));
}
